import React, { useState,useRef } from 'react';
import { Message } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import { Button, Icon } from 'semantic-ui-react';
import LoadingComponent from "../common/LoadingComponent";
import ModalHeader from '../drive/ModalHeader';
import logo from "../../images/logo/logo-white.png";
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { history } from '../../helpers';


const errorLabel = (
    <div 
      className="customErrorLabel" 
      style={{
        position: 'absolute',
        bottom: '-16px',
        left: '10px',
        color: 'red',
        fontSize: '8px'
      }}
    />
  );

const SignUpComponent = ({ 
    loggingIn, 
    loginError, 
    // handleGoogleLogin, 
    onSubmit,
    gotToForgotPassword, 
    // handleMicrosoftLogin, 
    version,
}) => {
    const [pageStep, setPageStep] = useState('choose');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const date = new Date();
    const formRef = useRef(null); 
    const [emailError, setEmailError] = useState("");
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState(false);
    const [termsAccepted, setTermsAccepted] = useState(false);
    const [termsError, setTermsError] = useState(false);


    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    }
    
    const handleFormSubmit = async (formData) => {
        if (!termsAccepted) {
            setTermsError(true);
            return;
        }
        if (password !== confirmPassword) {
            setConfirmPasswordError(true);
            return;
        }
        setConfirmPasswordError(false);
        setTermsError(false);
        setEmailError("");
        
        try {
            await dispatch.login.SignupAsync(formData);
            if (formRef.current) {
                formRef.current.reset();
            }
            history.push("/verify");
        } catch (error) {
            console.error("Signup error:", error);
            if (error.message.includes('already exists')) {
                setEmailError("User with this email already exists");
                //console.log("user Exist")
            } else {
                toastr.error("Error", "An unexpected error occurred during signup.");
            }
        }
    };


    const handleGoogleLogin = () => {
        const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback`;
        const scope = "openid email profile";
        const responseType = "code";
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    };

    const handleMicrosoftLogin=()=> {
        const clientId = process.env.REACT_APP_MICROSOFT_CLIENT_ID;
        const redirectUri = `${process.env.REACT_APP_ASPEN_SELF_URL}/auth/callback/microsoft`;
        const scope = "openid profile User.Read";
        const responseType = "code";
        const authUrl = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope)}`;
        window.location.href = authUrl;
    }

    const handleBack = (e) => {
        e.preventDefault();
        if (pageStep === 'email') {
            setPageStep('choose');
        } else {
            history.goBack();
        }
    }

    return (
        <div className="login-main" style={{ height: '100%' }}>
            <LoadingComponent active={loggingIn} message="Signing Up" />
            <div className="left-section">
                <div className='centered' style={{ justifyContent: "flex-start", paddingTop: "80px" }}>
                    <h2 className="f_24 ff_b float-left" style={{ color:"#707070", fontWeight: "normal", display: "flex", alignItems: "center", gap: "8px" }}>
                        <a href="#" onClick={handleBack} id="backLink" style={{
                            display: "flex", alignItems: "center", justifyContent: "center",
                            width: "28px", height: "28px",
                            border: "1px solid #d4d4d4", borderRadius: "6px",
                            color: "#707070", textDecoration: "none"
                        }}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="15 18 9 12 15 6"></polyline>
                            </svg>
                        </a>
                        {pageStep === 'email' ? 'Sign Up with Email' : 'Sign Up'}
                    </h2>

                    <Form
                        ref={formRef}
                        noValidate
                        className="loginform"
                        error={!!loginError}
                        onValidSubmit={handleFormSubmit}
                        id="signupform"
                    >
                        {loginError && <Message error content={loginError.message} />}
                        {
                            pageStep === 'choose' ? (
                                <div>
                                    <Button
                                        onClick={handleGoogleLogin}
                                        className='mar_tb_5 display-flex login-btn'
                                        type="button"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="16px" height="16px">
                                        <path fill="#4285F4" d="M46.8 24.42c0-1.42-.13-2.79-.36-4.12H24v7.77h12.84c-.56 3.01-2.22 5.55-4.73 7.26v6.02h7.66c4.48-4.13 7.04-10.22 7.04-16.93z"/>
                                        <path fill="#34A853" d="M24 48c6.32 0 11.61-2.09 15.48-5.67l-7.66-6.02c-2.13 1.43-4.84 2.29-7.82 2.29-6.02 0-11.12-4.07-12.94-9.55H3.17v6.09C7.09 42.9 14.98 48 24 48z"/>
                                        <path fill="#FBBC05" d="M11.06 28.75a14.63 14.63 0 0 1 0-9.49V13.17H3.17a24.03 24.03 0 0 0 0 21.66l7.89-6.08z"/>
                                        <path fill="#EA4335" d="M24 9.42c3.33 0 6.31 1.15 8.67 3.4l6.47-6.47C34.51 2.47 29.92 0 24 0 14.98 0 7.09 5.1 3.17 13.17l7.89 6.08C12.88 13.49 17.98 9.42 24 9.42z"/>
                                        </svg>
                                        <span style={{marginLeft:"4px", fontSize:"12px"}} className='ff_sb'> Sign Up with Google</span>
                                    </Button>

                                    <Button
                                        onClick={handleMicrosoftLogin}
                                        className='mar_tb_5 display-flex login-btn'
                                        type="button"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18px" height="18px">
                                        <path fill="#F25022" d="M6 6h17v17H6z"/>
                                        <path fill="#7FBA00" d="M25 6h17v17H25z"/>
                                        <path fill="#00A4EF" d="M6 25h17v17H6z"/>
                                        <path fill="#FFB900" d="M25 25h17v17H25z"/>
                                        </svg>
                                        <span style={{marginLeft:"4px", fontSize:"12px"}} className='ff_sb'> Sign Up with Microsoft</span>
                                    </Button>

                                    <Button
                                        onClick={() => setPageStep('email')}
                                        className='mar_tb_5 display-flex login-btn'
                                        type="button"
                                    >
                                        <Icon name="envelope" style={{ color: "#707070" }} />
                                        <span style={{marginLeft:"4px", fontSize:"12px"}} className='ff_sb'> Sign Up with Email</span>
                                    </Button>

                                    <p style={{ fontSize: "11px", fontWeight: "500", textAlign: "center", marginTop: "16px" }}>
                                        By continuing, I agree to the{" "}
                                        <a href="https://aspenify.com/terms-of-service/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Terms of Service</a>,{" "}
                                        <a href="https://aspenify.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Privacy Policy</a> and{" "}
                                        <a href="https://aspenify.com/disclaimer/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Disclaimer</a>.
                                        {" "}Aspenify includes optional AI playbook generation.
                                    </p>

                                    <div style={{ textAlign: "center" }}>
                                        <a
                                            href="/login"
                                            className="typeAnchor underline-hover ff_sb"
                                            onClick={gotToForgotPassword}
                                            id="forgetLink"
                                            style={{fontSize:"12px"}}
                                        >
                                            Already have an account? Log In
                                        </a>
                                    </div>
                                </div>
                            ) : (
                        <>
                        <div style={{ display: "flex", gap: "12px", marginBottom:"15px" }}>

                         <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
                            <Form.Input
                                name="firstName"
                                label="First Name"
                                placeholder="Enter First Name"
                                required
                                validations="isAlphanumeric"
                                errorLabel={errorLabel}
                                validationErrors={{
                                    isAlphanumeric: 'Only letters and numbers are allowed',
                                    isDefaultRequiredValue: 'First Name is required',
                                }}
                                id="firstName"
                                onBlur={(e) => {
                                    setFirstNameError(e.target.value.trim() === "");
                                }}
                                onChange={(e) => {
                                    if (e.target.value.trim() !== "") {
                                        setFirstNameError(false);
                                    }
                                }}
                                style={{
                                    width: "100%",
                                    marginTop: "1px"
                                }}
                                validateOnBlur
                            />
                        </div>

                         <div style={{ flex: 1, minWidth: 0, position: "relative" }}>
                                    <Form.Input
                                        name="lastName"
                                        label="Last Name"
                                        placeholder="Enter Last Name"
                                        required
                                        validations="isAlphanumeric"
                                        errorLabel={errorLabel}
                                        validationErrors={{
                                            isAlphanumeric: 'Only letters are allowed',
                                            isDefaultRequiredValue: 'Last Name is required',
                                        }}
                                        id="lastName"
                                        onBlur={(e) => {
                                            setLastNameError(e.target.value.trim() === "");
                                        }}
                                        onChange={(e) => {
                                            if (e.target.value.trim() !== "") {
                                                setLastNameError(false);
                                            }
                                        }}
                                        style={{
                                            width: "100%",
                                            marginTop: "1px"
                                        }}
                                        validateOnBlur
                                    />
                            </div>
                        </div>
                        
                        <div style={{ paddingLeft: "10px",gap:"10px", marginLeft: "-10px", position: "relative",marginTop:"5px"}}>
                            <Form.Input
                            name="email"
                            label="Email"
                            placeholder="Enter Email"
                            icon="envelope"
                            iconPosition="left"
                            required
                            validations="isEmail"
                            errorLabel={errorLabel}
                            validationErrors={{
                                isEmail: 'This is not a valid email',
                                isDefaultRequiredValue: 'Email is required',
                            }}
                            id="email"
                            autoFocus
                            style={{marginTop:"1px"}}
                            onChange={() => setEmailError("")}
                        />
                        {emailError && (
                            <div 
                                style={{
                                    position: 'absolute',
                                    bottom: '-16px',
                                    left: '10px',
                                    color: 'red',
                                    fontSize: '8px'
                                }}
                            >
                                {emailError}
                            </div>
                        )}

                        </div>
                        
                        <div style={{ paddingLeft: "10px", gap:"10px", marginLeft: "-10px", position: "relative", marginTop: "15px" }}>
                            <Form.Input
                                name="password"
                                icon='key'
                                iconPosition='left'
                                label="Password"
                                type={showPassword ? 'text' : 'password'}
                                required
                                placeholder="Enter Password"
                                autoComplete="new-password"
                                errorLabel={errorLabel}
                                validationErrors={{
                                    isDefaultRequiredValue: 'Password is required',
                                    minLength: 'Password must be at least 8 characters long',
                                    sameAsEmail: 'Password cannot be the same as your email address',
                                }}
                                id="password"
                                action={<Icon
                                    name={showPassword ? 'eye' : 'eye slash'}
                                    link
                                    onClick={togglePasswordVisibility}
                                    style={{left: "auto", right: "1px"}}
                                />}
                                validateOnBlur
                                validations={{
                                    minLength: 8,
                                    sameAsEmail: (values) => {
                                        return values.email && values.password && values.password.toLowerCase() !== values.email.toLowerCase()
                                    }
                                }}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{marginTop:"1px"}}
                            />
                        </div>
                        
                    <div style={{ paddingLeft: "10px", gap:"10px", marginLeft: "-10px", position: "relative", marginTop: "15px" }}>
                        <Form.Input
                            name="confirmPassword"
                            icon='key'
                            iconPosition='left'
                            label="Confirm Password"
                            type={showConfirmPassword ? 'text' : 'password'}
                            required
                            placeholder="Confirm Password"
                            autoComplete="new-password"
                            errorLabel={errorLabel}
                            validationErrors={{
                                isDefaultRequiredValue: 'Confirm Password is required',
                                passwordMatch: 'Passwords do not match'
                            }}
                            validations={{
                                passwordMatch: (values, value) => (!value || value === password)
                            }}
                            id="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => {
                                const value = e.target.value;
                                setConfirmPassword(value);
                                if (value && value !== password) {
                                    setConfirmPasswordError(true);
                                } else {
                                    setConfirmPasswordError(false);
                                }
                            }}
                            action={<Icon
                                name={showConfirmPassword ? 'eye' : 'eye slash'}
                                link
                                onClick={toggleConfirmPasswordVisibility}
                                style={{left: "auto", right: "1px"}}
                            />}
                            error={confirmPasswordError}
                            style={{marginTop:"1px"}}
                        />
                    </div>
                    
                        <div style={{ display: "flex", alignItems: "flex-start", marginTop: "20px", gap: "8px" }}>
                            <input
                                type="checkbox"
                                id="termsCheckbox"
                                checked={termsAccepted}
                                onChange={(e) => {
                                    setTermsAccepted(e.target.checked);
                                    if (e.target.checked) setTermsError(false);
                                }}
                                style={{ marginTop: "2px", cursor: "pointer", flexShrink: 0 }}
                            />
                            <label htmlFor="termsCheckbox" style={{ fontSize: "11px", fontWeight: "500", color: "#555", cursor: "pointer", lineHeight: "1.5" }}>
                                By continuing, I agree to the{" "}
                                <a href="https://aspenify.com/terms-of-service/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Terms of Service</a>,{" "}
                                <a href="https://aspenify.com/privacy-policy/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Privacy Policy</a> and{" "}
                                <a href="https://aspenify.com/disclaimer/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>Disclaimer</a>.
                                {" "}Aspenify includes optional AI playbook generation.
                            </label>
                        </div>
                        {termsError && (
                            <div style={{ color: "red", fontSize: "8px", marginTop: "4px", marginLeft: "20px" }}>
                                You must accept the terms and conditions to continue.
                            </div>
                        )}

                        <div className="display-flex" style={{ flexDirection: "column", alignItems: "center", width: "100%" }}>
                            <Button 
                                className="button-submit mar_t_10" 
                                type="submit" 
                                id="submit" 
                                style={{ width: "100%" }}
                            >
                                Sign Up
                            </Button>
                            <a
                                href="/login"
                                className="typeAnchor underline-hover ff_sb"
                                onClick={gotToForgotPassword}
                                id="forgetLink"
                                style={{marginTop:"5px",fontSize:"12px", fontWeight:"600", color:"#3EA2F7", textAlign:"center"}}
                            >
                                Already have an account? Log In
                            </a>
                        </div>
                        </>
                            )
                        }
                    </Form>
                </div>
                <div className="f_8 mar_0 bottom" style={{  height: "46px", padding: "5px 10px",width:"100%"}}>
                    <div className="float-left">
                        Copyright &#169; {date.getFullYear()} Aspenify <br />Version {version ? version : ""}
                    </div>
                    <div className="float-right text-right">
                        Visit us at <br />
                        <a href="https://www.aspenify.com" rel="noopener noreferrer" style={{ color: "#6b6b6b" }} target="_blank" > www.aspenify.com </a>
                    </div>
                </div>
            </div>
            <div className="right-section display-flex " style={{ flexDirection: 'column' }}>
                        <div className='login-right-div ' >
                            <div>
                                <ModalHeader 
                                header={<a href="https://aspenify.com" target="_blank" rel="noopener noreferrer"><img src={`${logo}`} alt="Logo" style={{ width: '40vw', height: 'auto', cursor:'pointer' }} /></a>}
                                />
                            </div>
                            {/* <div className='login-right-info'>
                                <h1 className='f_32'>
                                    Scalable Solutions.<br></br>
                                    Consistent Results.
                                </h1>
            
                                <span className='f_18 mar_tb_10' style ={{lineHeight: '25px'}}> 
                                    Design, develop and manage digital<br/> 
                                    application solutions.
                                </span>
                            </div>
            
                            <div className='right-divider'></div>
            
                            <div className='login-right-info'>
                                <span className='f_18 mar_tb_20' style ={{ lineHeight: '25px'}}>
                                    Create with our growing community of customers, <br></br>
                                    partners and co-creators.
                                </span>
                            </div>
            
                            <div className='right-box'>
                                <div  className='f_18 line-space' >
                                    <span>5,000+<br/>Playbooks & <br/> Initiatives</span>
                                </div>
                                <div  className='f_18 line-space'>
                                    <span>250,000+ <br></br>Users</span>
                                </div>
                                <div  className='f_18 line-space'>
                                    <span>30,000+ <br></br>Knowledgebase<br></br> Articles</span>
                                </div>
                            </div>   */}
                        </div>
                </div>
        </div>
    );
};

export default SignUpComponent;